// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"8252":"css/app","8769":"css/intray-uploader"}[chunkId] + ".css";
};